import React from "react";
import "./Health_Innovation.css";

const Health_Innovation = () => {
  return (
    <section id="about_section" className="health_section">
      <div className="container">
        <div className="health_title_holder">
          <h2 className="health_title">HEALTH & INNOVATION</h2>
          <p className="health_subtitle">
            At <span className="gym">Gym</span>
            <span className="ify">ify</span> , our passion lies at the
            intersection of health and innovation.
          </p>
        </div>

        <div className="health_content_holder">
          <p className="health_content">
            We’ve built a platform that bridges the gap between & and your
            fitness goals, making gym access simpler than ever. We are committed
            to partnering with high-quality fitness centers & wellness experts,
            ensuring your journey is supported by the best facilities, flexible
            plans, & technology that moves with you.
          </p>
        </div>
      </div>
    </section>
  );
};

export default Health_Innovation;
